export default __webpack_public_path__ + "static/media/notification-success.91e786c0.svg";